<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "CurrencyComponent",
};
</script>

<style scoped></style>
